import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getGoogleDriveId } from "../../utils/generalFunction";
export {};

interface ProductDetailImageProps {
  productsImages: string[];
}

const ProductDetailImage: React.FC<ProductDetailImageProps> = (props) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = React.useMemo(
    () => (Array.isArray(props.productsImages) ? props.productsImages : []),
    [props.productsImages]
  );

  const settings = {
    customPaging: function (i: number) {
      return (
        <img
          src={`https://images.weserv.nl/?url=https://drive.google.com/uc?id=${getGoogleDriveId(
            images[i]
          )}`}
          alt={`Product thumbnail ${i + 1}`}
          style={{
            width: "100px",
            height: "80px",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  function NextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={
          className +
          " bg-primary_gray/20 z-[999] right-5 shadow-lg shadow-slate-600/50 w-[50px] h-[50px] !flex !items-center !justify-center rounded-full hover:shadow-slate-500 transition-shadow duration-300 hover:bg-primary_blue/00 text-white"
        }
        style={{ ...style }}
        onClick={onClick}
      >
        <ArrowForwardIosIcon style={{ color: "darkgray" }} />
      </div>
    );
  }

  function PrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={
          className +
          " bg-primary_gray/20 z-[999] left-5 shadow-lg shadow-slate-600/50 w-[50px] h-[50px] !flex !items-center !justify-center rounded-full hover:shadow-slate-500 transition-shadow duration-300 hover:bg-primary_blue/00 text-white"
        }
        style={{ ...style }}
        onClick={onClick}
      >
        <ArrowBackIosNewIcon style={{ color: "darkgray" }} />
      </div>
    );
  }

  const handleImageClick = (image: any, index: any) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const handlePrevImage = React.useCallback(() => {
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(images[newIndex]);
  }, [currentImageIndex, images]);

  const handleNextImage = React.useCallback(() => {
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(images[newIndex]);
  }, [currentImageIndex, images]);

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (!selectedImage) return;
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "ArrowRight") handleNextImage();
      if (e.key === "Escape") handleCloseModal();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImage, currentImageIndex, handlePrevImage, handleNextImage]);

  return (
    <div className="slider-container bg-white rounded-xl  shadow-md">
      <Modal
        open={!!selectedImage}
        onClose={handleCloseModal}
        aria-labelledby="image-modal"
        className="flex items-center justify-center "
      >
        <Box className="outline-none relative">
          <img
            src={`https://images.weserv.nl/?url=https://drive.google.com/uc?id=${getGoogleDriveId(
              selectedImage ?? ""
            )}`}
            alt="Full size"
            className="max-w-[90vw] max-h-[90vh] object-contain rounded"
          />

          <IconButton
            onClick={handlePrevImage}
            aria-label="prev"
            className="!absolute !left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75"
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <IconButton
            onClick={handleNextImage}
            aria-label="next"
            className="!absolute !right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75"
          >
            <ArrowForwardIosIcon />
          </IconButton>
          <IconButton
            onClick={handleCloseModal}
            aria-label="close"
            className="!absolute !top-4 !right-4 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75 w-8 h-8"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Modal>
      <Slider {...settings}>
        {images && images.length > 0 ? (
          images.map((image, index) => (
            <div key={index} className="rounded-2xl">
              <div className="flex items-center justify-center">
                <img
                  src={`https://images.weserv.nl/?url=https://drive.google.com/uc?id=${getGoogleDriveId(
                    image
                  )}`}
                  alt={`Product ${index + 1}`}
                  onClick={() => handleImageClick(image, index)}
                  className="rounded-2xl max-h-[50vh] p-3"
                />
              </div>
            </div>
          ))
        ) : (
          <div>
            <img
              src="https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"
              alt="Placeholder"
              style={{ width: "100%", height: "auto" }}
            />
          </div>
        )}
      </Slider>
    </div>
  );
};

export default ProductDetailImage;
